import React from 'react';
import { inject, observer } from 'mobx-react';
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { Button, NoData } from 'oned';
import { AmplitudeEventName, ProblemLevel } from '@common/enums/base';
import SvgImage from './svgImage';
import classnames from 'classnames';
import { getCurrentEnv, sendAmplitude_Default } from '@common/utils';
import Cookies from "js-cookie";
var LevelThree = inject(ProblemBusiness)(observer(function (props) {
    var levelOneName = props.levelOneName, levelTwoName = props.levelTwoName, levelThreeAliasList = props.levelThreeAliasList, setProblemAlias = props.setProblemAlias, clearAfterStepData = props.clearAfterStepData, currentUser = props.currentUser, problemCaseCadeName = props.problemCaseCadeName, isAliasingView = props.isAliasingView, serviceCodeCheck = props.serviceCodeCheck, clearCommonStoreKeepStatus = props.clearCommonStoreKeepStatus;
    var jumpStep = function (alias) {
        setProblemAlias(alias, ProblemLevel.LevelThree);
        clearAfterStepData();
        clearCommonStoreKeepStatus();
        serviceCodeCheck(alias);
        sendAmplitude_Default(AmplitudeEventName.NewRSP_Step1to2, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            problemLevel1: levelOneName,
            problemLevel2: levelTwoName,
            problemLevel3: alias.name,
            serviceCombo: problemCaseCadeName,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv(),
        });
    };
    return React.createElement("div", null,
        React.createElement("div", { className: 'row mt-4' },
            React.createElement("div", { className: 'col-12' },
                React.createElement("h2", { className: 'problem-title' },
                    React.createElement("b", null, isAliasingView ? "What is wrong with the " + levelTwoName.toLocaleLowerCase() + "?" : 'Problem code')))),
        React.createElement("div", { className: 'row' },
            levelThreeAliasList.length > 0 && levelThreeAliasList.map(function (alias) { return (React.createElement("div", { className: 'col-md-6 col-sm-12' }, isAliasingView ?
                React.createElement("div", { className: 'rsp-card my-2 cp levle3-wrapper', onClick: function () { return jumpStep(alias); } },
                    React.createElement("div", { className: 'rsp-card-body d-flex' },
                        React.createElement(SvgImage, { iconUrl: alias.iconUrl }),
                        React.createElement("div", { className: 'pl-3' },
                            React.createElement("div", null,
                                React.createElement("b", null, alias.name)),
                            React.createElement("div", { className: 'levle3-detail' }, alias.iconDescription)))) :
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14 newRequest-primary service-option'), onClick: function () { return jumpStep(alias); } }, alias.name))); }),
            !levelThreeAliasList || levelThreeAliasList.length === 0 &&
                React.createElement("div", { className: 'w-100 d-flex justify-content-center' },
                    React.createElement(NoData, null))));
}));
export default LevelThree;
